/**
 * 別チーム構築中の CorporateSite / ServiceSite の暫定モックページ。
 * 画像を1枚表示し、指定位置に透明クリック領域（ホットスポット）を重ねて遷移させる。
 * ホットスポットは画像に対する % 指定なので、ウィンドウ幅が変わっても位置がズレない。
 */
import React from 'react';

export interface Hotspot {
  /** 画像幅・高さに対する % (0-100) */
  left: number;
  top: number;
  width: number;
  height: number;
  onClick: () => void;
  label: string;
}

export const MockImagePage: React.FC<{
  src: string;
  alt: string;
  hotspots?: Hotspot[];
  /** 画像全体をクリックした時の遷移（CorporateSite 用） */
  onImageClick?: () => void;
}> = ({ src, alt, hotspots = [], onImageClick }) => {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', background: '#ffffff' }}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: 1440,
          cursor: onImageClick ? 'pointer' : 'default',
          lineHeight: 0,
        }}
        onClick={onImageClick}
      >
        <img src={src} alt={alt} style={{ width: '100%', height: 'auto', display: 'block' }} />
        {hotspots.map((h, i) => (
          <button
            key={i}
            type="button"
            aria-label={h.label}
            title={h.label}
            onClick={(e) => {
              e.stopPropagation();
              h.onClick();
            }}
            style={{
              position: 'absolute',
              left: `${h.left}%`,
              top: `${h.top}%`,
              width: `${h.width}%`,
              height: `${h.height}%`,
              background: 'transparent',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default MockImagePage;
